import { FilterModel } from "@app/models/customer-transaction-history/Transaction-Filter-model";

export class SearchMerchant{
    MerchantId:number;
    MerchantType:string;
    MerchantTypeId:number;
    ParentMerchantId:number;
    ParentMerchant:string;
    Code:number;
    Name:string;
    City:string;
    AcquirerId:number;
    ExternalId:string;
    OutletId:number;
    OutletCode:number;
    MID:number;
    MCode:number;
    MerchantAddress:string;
    Location:string;
    ContactNumber:string;
    TerminalNumber:number;
    Status:string;
    Category:string;
    AcquirerName:string;
    SkipCount:number;
    Count:number;
    filterModel=new FilterModel();
}


// WEBPACK FOOTER //
// ./src/app/models/merchant/SearchMerchant.ts